import { createAction } from '@reduxjs/toolkit'

import type {
  AddMultipleScheduledExercisesRequestPayload,
  AddMultipleScheduledExercisesSuccessPayload,
  AssignScheduleRequestPayload,
  DeleteScheduledExercisesByIdsRequestPayload,
  DeleteScheduledExercisesByIdsSuccessPayload,
  DeleteScheduleRequestPayload,
  DeleteScheduleSuccessPayload,
  EditScheduledExercisesByIdsRequestPayload,
  EditScheduledExercisesByIdsSuccessPayload,
  EditScheduledExerciseSettingsByIdsRequestPayload,
  EditScheduledExerciseSettingsByIdsSuccessPayload,
  EditScheduleRequestPayload,
  GetSchedulesRequestPayload,
  GetSchedulesSuccessPayload,
  GetSingleScheduleRequestPayload,
  GetSingleScheduleSuccessPayload,
  SchedulesModel
} from './types'

export const resetSchedules = createAction('RESET_SCHEDULES')

export const getSchedulesRequest = createAction<
  GetSchedulesRequestPayload | undefined
>('GET_SCHEDULES_REQUEST')
export const getSchedulesSuccess = createAction<GetSchedulesSuccessPayload>(
  'GET_SCHEDULES_SUCCESS'
)
export const getSchedulesFailed = createAction('GET_SCHEDULES_FAILED')

export const assignScheduleRequest = createAction<AssignScheduleRequestPayload>(
  'ASSIGN_SCHEDULE_REQUEST'
)
export const assignScheduleSuccess = createAction('ASSIGN_SCHEDULE_SUCCESS')
export const assignScheduleFailed = createAction('ASSIGN_SCHEDULE_FAILED')

export const getSingleScheduleRequest =
  createAction<GetSingleScheduleRequestPayload>('GET_SINGLE_SCHEDULE_REQUEST')
export const getSingleScheduleSuccess =
  createAction<GetSingleScheduleSuccessPayload>('GET_SINGLE_SCHEDULE_SUCCESS')
export const getSingleScheduleFailed = createAction(
  'GET_SINGLE_SCHEDULE_FAILED'
)

export const editScheduleRequest = createAction<EditScheduleRequestPayload>(
  'EDIT_SCHEDULE_REQUEST'
)
export const editScheduleSuccess = createAction<SchedulesModel>(
  'EDIT_SCHEDULE_SUCCESS'
)
export const editScheduleFailed = createAction('EDIT_SCHEDULE_FAILED')

export const deleteScheduleRequest = createAction<DeleteScheduleRequestPayload>(
  'DELETE_SCHEDULE_REQUEST'
)
export const deleteScheduleSuccess = createAction<DeleteScheduleSuccessPayload>(
  'DELETE_SCHEDULE_SUCCESS'
)
export const deleteScheduleFailed = createAction('DELETE_SCHEDULE_FAILED')

export const editScheduledExerciseSettingsByIdsRequest =
  createAction<EditScheduledExerciseSettingsByIdsRequestPayload>(
    'EDIT_SCHEDULED_EXERCISE_SETTINGS_BY_IDS_REQUEST'
  )
export const editScheduledExerciseSettingsByIdsSuccess =
  createAction<EditScheduledExerciseSettingsByIdsSuccessPayload>(
    'EDIT_SCHEDULED_EXERCISE_SETTINGS_BY_IDS_SUCCESS'
  )
export const editScheduledExerciseSettingsByIdsFailed = createAction(
  'EDIT_SCHEDULED_EXERCISE_SETTINGS_BY_IDS_FAILED'
)

export const deleteScheduledExercisesByIdsRequest =
  createAction<DeleteScheduledExercisesByIdsRequestPayload>('DELETE_SCHEDULED_EXERCISES_BY_IDS_REQUEST')
export const deleteScheduledExercisesByIdsSuccess =
  createAction<DeleteScheduledExercisesByIdsSuccessPayload>('DELETE_SCHEDULED_EXERCISES_BY_IDS_SUCCESS')
export const deleteScheduledExercisesByIdsFailed =
  createAction('DELETE_SCHEDULED_EXERCISES_BY_IDS_FAILED')

export const addMultipleScheduledExercisesRequest =
  createAction<AddMultipleScheduledExercisesRequestPayload>('ADD_MULTIPLE_SCHEDULED_EXERCISES_REQUEST')
export const addMultipleScheduledExercisesSuccess =
  createAction<AddMultipleScheduledExercisesSuccessPayload>('ADD_MULTIPLE_SCHEDULED_EXERCISES_SUCCESS')
export const addMultipleScheduledExercisesFailed =
  createAction('ADD_MULTIPLE_SCHEDULED_EXERCISES_FAILED')

export const editScheduledExercisesByIdsRequest =
  createAction<EditScheduledExercisesByIdsRequestPayload>('EDIT_SCHEDULED_EXERCISES_BY_IDS_REQUEST')
export const editScheduledExercisesByIdsSuccess =
  createAction<EditScheduledExercisesByIdsSuccessPayload>('EDIT_SCHEDULED_EXERCISES_BY_IDS_SUCCESS')
export const editScheduledExercisesByIdsFailed =
  createAction('EDIT_SCHEDULED_EXERCISES_BY_IDS_FAILED')
